module.exports = __webpack_public_path__ + "img/spins_1248.18e2436a.png";